export default __webpack_public_path__ + "static/media/Matrices.888be417.pdf";